import styled from 'styled-components'
import { SeatSellingMode, SeatSellingModes } from 'types/Event'

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 800px;
    margin: auto;
    padding: 0 20px;

    @media (max-width: 1600px) {
        width: 100%;
        padding: 0 20px;
    }
`

export const ContainerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: left;
    width: 100%;
`

export const FormContent = styled.div<{ mode: SeatSellingMode }>`
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 0px 0px 4px 4px;
    border-top: none;
    background: #fff;

    ${({ mode }) =>
        mode === SeatSellingModes.SeatBased &&
        `
        /* Additional styles for manual mode if needed */
    `}

    ${({ mode }) =>
        mode === SeatSellingModes.General &&
        `
        /* Additional styles for automatic mode if needed */
    `}
`

export const SectionLabel = styled.p`
    margin-top: 2rem;
    margin-bottom: 1rem;
    font-weight: 600;
    font-size: 18px;
`
